import runWithFPS from 'run-with-fps';
import lerp from 'lerp';
import eases from 'eases';

const PROGRESS_PRECISION = 4;

const updatesHandlers = [];
const scrollHandlers = [];

function removeHandler(handlers, handler) {
  const i = handlers.indexOf(handler);
  handlers.splice(i, 1);
}

runWithFPS(() => {
  updatesHandlers.forEach((upd) => upd());
}, 60);

window.addEventListener(
  'scroll',
  () => {
    scrollHandlers.forEach((handler) => handler());
  },
  { passive: true }
);

function round(n, precision) {
  const dec = 10 ** precision;
  return Math.round(n * dec) / dec;
}

const noop = () => null;

export function scrollAnimationProgress(
  el,
  { getStart = () => 0, getEnd = () => 0, lerpValue = 0.1, onProgress = noop } = {},
  easing = eases.linear
) {
  const lerpEnabled = lerpValue < 1;
  let currentProgress = 0;
  let nextProgress = 0;

  const updateProgress = (progress) => {
    el.style.setProperty('--progress', progress);
    onProgress(progress);
  };

  const resetProgress = () => {
    el.style.removeProperty('--progress');
    onProgress(0);
  };

  const handleScroll = () => {
    const start = getStart(el);
    const end = getEnd(el, start);
    const progress = Math.min(1, Math.max(0, (window.scrollY - start) / (end - start)));

    nextProgress = round(progress, PROGRESS_PRECISION);

    if (!lerpEnabled) {
      updateProgress(easing(progress));
    }
  };

  let prevDelta = 0;
  const handleUpdate = () => {
    if (lerpEnabled) {
      currentProgress = round(lerp(currentProgress, nextProgress, lerpValue), PROGRESS_PRECISION);
      const delta = currentProgress - nextProgress;
      if (prevDelta !== delta) {
        prevDelta = delta;
        updateProgress(easing(currentProgress));
      }
    }
  };

  updateProgress(currentProgress);
  scrollHandlers.push(handleScroll);
  updatesHandlers.push(handleUpdate);
  handleScroll();

  return () => {
    resetProgress();
    removeHandler(scrollHandlers, handleScroll);
    removeHandler(updatesHandlers, handleUpdate);
  };
}
